import { ContextConstants } from "utils/constants";
import { FileViewerActionType } from "models/actionTypes/fileViewerActionTypes";
import { FileViewerContextState } from "models/propTypes/fileViewerPropTypes";

export const FileViwerReducer = (
  state: FileViewerContextState,
  action: FileViewerActionType
): FileViewerContextState => {
  switch (action.type) {
    case ContextConstants.FileViewerActions.SET_UPLOADED_FILE_DIMENSIONS:
      return {
        ...state,
        currentFileDimensions: action.payload,
      };
    case ContextConstants.FileViewerActions.SET_CONTAINER_DIMENSIONS:
      return {
        ...state,
        containerDimensions: action.payload,
      };
    default:
      return state;
  }
};
